export default "__VITE_ASSET__CnSX_eNm__"